import { alpha } from "../../utils/muiCompat";
import { LARGURA_RAIL as railWidth, LARGURA_SIDEBAR as drawerWidth } from "../../containers/Templates/appStyles-jss";
import lightGreen from "@material-ui/core/colors/lightGreen";
import red from "@material-ui/core/colors/red";
import amber from "@material-ui/core/colors/amber";
import grey from "@material-ui/core/colors/grey";
import { PALETA_ESCURA } from "../../styles/theme/paletaCores";

const styles = (theme: any) => ({
  user: {
    justifyContent: "center"
  },
  drawerPaper: {
    position: "relative",
    height: "100%",
    overflow: "hidden",
    border: "none",
    background: "none",
    color: theme.palette.type === "dark" ? theme.palette.text.primary : theme.palette.common.white,
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  swipeDrawerPaper: {
    width: drawerWidth,
    // em celular os 340px do drawer cobririam quase toda a tela
    maxWidth: "85vw",
    border: "none",
    backgroundColor:
      theme.palette.type === "dark" ? PALETA_ESCURA.fundoMenuLateral : theme.palette.primary.dark,
    // sem cor propria o paper do MUI deixa o texto no preto padrao, ilegivel sobre o azul
    color: theme.palette.common.white
  },
  botaoFechar: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 2,
    color: theme.palette.common.white
  },
  opened: {
    "& $primary, & $icon": {
      color: theme.palette.common.white
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: 5,
      height: theme.spacing(5),
      top: 0,
      left: 0,
      background: alpha(theme.palette.common.white, 0.4)
    }
  },
  drawerPaperClose: {
    width: railWidth,
    position: "absolute",
    overflowX: "hidden",
    background: theme.palette.type === "dark" ? PALETA_ESCURA.fundoMenuLateral : theme.palette.primary.dark,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.leavingScreen
    }),
    // fechado (rail): icones centralizados. No hover a barra expande e volta ao alinhamento
    // normal (com os labels). Seletor global do MUI porque os itens vem do SidebarLink.
    "&:not($railExpandido)": {
      // o menuContainer tem width = drawerWidth (340). Sem limitar ao rail, centralizar os
      // itens os jogava para o centro dos 340px -- fora da area visivel do rail (overflow
      // hidden), fazendo os icones "sumirem".
      "& $menuContainer": {
        width: railWidth,
        // a classe "rounded" aplica paddingRight 12px (respiro da borda arredondada dos itens);
        // no rail isso reduzia a area util para 78px e tirava os icones do centro
        paddingRight: 0,
        // idem para a barra de rolagem: escondida aqui, o scroll segue pela roda do mouse
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none"
        }
      },
      "& .MuiListItem-root": {
        justifyContent: "center",
        paddingLeft: 0,
        paddingRight: 0
      },
      "& .MuiListItemIcon-root": {
        minWidth: "auto"
      },
      // esconde o texto no rail para o icone ficar realmente centralizado (o texto, mesmo
      // clipado pela largura, ocupava espaco e empurrava o icone para a esquerda)
      "& .MuiListItemText-root": {
        display: "none"
      },
      // chevron das categorias (ExpandLess/More): no rail ele entrava na centralizacao e
      // empurrava o icone para a esquerda
      '& svg[class^="MuiSvgIcon"]': {
        display: "none"
      },
      "& .MuiListItem-root[aria-current=page]": {
        backgroundColor: "transparent",
        boxShadow: `inset 4px 0 0 ${theme.palette.common.white}`
      }
    },
    "& $user": {
      justifyContent: "flex-start"
    },
    "& $bigAvatar": {
      width: 40,
      height: 40
    },
    "& nav": {
      display: "none"
    },
    "&$railExpandido": {
      width: drawerWidth,
      boxShadow: theme.shadows[6],
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      // logo e textos so aparecem depois que a largura terminou de crescer: durante a
      // expansao eles ficariam cortados pela borda do menu
      '& $brand, & .MuiListItemText-root, & svg[class^="MuiSvgIcon"]': {
        animation: `$surgirConteudoMenu ${theme.transitions.duration.shorter}ms ${theme.transitions.easing.easeOut} ${theme.transitions.duration.enteringScreen}ms both`
      },
      // a logo volta fora do fluxo: o paddingTop do menuContainer ja reserva o lugar dela,
      // entao os itens do menu nao descem ao expandir
      "& $brand": {
        display: "flex",
        position: "absolute",
        top: 0,
        left: 0
      },
      // expandida por hover, os icones ficam na mesma coluna do rail: a caixa do icone
      // ocupa exatamente a largura do rail e o texto comeca depois dela
      "& .MuiListItem-root": {
        paddingLeft: 0
      },
      "& .MuiListItemIcon-root": {
        minWidth: railWidth,
        display: "flex",
        justifyContent: "center"
      },
      // o texto reaparece e, com a altura de linha propria, aumentaria a altura do item
      "& .MuiListItemText-root": {
        marginTop: 0,
        marginBottom: 0
      },
      "& .MuiListItemText-root .MuiTypography-root": {
        lineHeight: "24px"
      },
      "& nav": {
        display: "block"
      }
    },
    "& $brand": {
      display: "none"
    },
    "& $profile": {
      flexDirection: "row",
      top: theme.spacing(6),
      padding: theme.spacing(0.5),
      textAlign: "left",
      "& button": {
        width: "auto"
      }
    },
    "& $avatar": {
      marginRight: theme.spacing(3)
    },
    "& $menuContainer": {
      // 64px e a altura do antigo cabecalho da logo, que ficava acima da area que rola
      "&$menuContainer": {
        paddingTop: theme.spacing(15) + 64,
        paddingBottom: 0
      }
    }
  },
  railExpandido: {},
  "@keyframes surgirConteudoMenu": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  drawerInner: {
    // Make the items inside not wrap when transitioning:
    height: "100%",
    position: "fixed",
    backgroundColor:
      theme.palette.type === "dark" ? PALETA_ESCURA.fundoMenuLateral : theme.palette.primary.dark,
    boxShadow: theme.shade.light
  },
  drawerInnerMobile: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor:
      theme.palette.type === "dark" ? PALETA_ESCURA.fundoMenuLateral : theme.palette.primary.dark,
    color: theme.palette.common.white
  },
  drawerHeaderOpen: {
    padding: "0",
    zIndex: 1,
    position: "relative"
  },
  avatar: {
    margin: 10
  },
  bigAvatar: {
    width: 80,
    height: 80,
    boxShadow: theme.glow.light
  },
  brandBar: {
    transition: theme.transitions.create(["width", "margin", "background"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    "&:after": {
      transition: theme.transitions.create(["box-shadow"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    }
  },
  darker: {
    background: "none"
  },
  nested: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    margin: `${theme.spacing(0.5)}px 0`,
    [theme.breakpoints.down("lg")]: {
      paddingLeft: theme.spacing(3)
    }
  },
  child: {
    "& a": {
      paddingLeft: theme.spacing(6)
    }
  },
  neto: {
    "& a": {
      paddingLeft: theme.spacing(8)
    }
  },
  title: {
    fontSize: 10,
    textTransform: "uppercase",
    paddingLeft: theme.spacing(10),
    marginTop: theme.spacing(3),
    display: "block",
    color: theme.palette.secondary.main,
    lineHeight: "28px",
    fontWeight: "bold"
  },
  dense: {
    "& > $title:first-child": {
      margin: "0"
    },
    // DASH-31: recuo dos subitens em relacao ao item pai. O ListItem vem do
    // SidebarLink (folha JSS propria), por isso o seletor global do MUI.
    "& .MuiListItem-root": {
      paddingLeft: theme.spacing(4)
    },
    // bullet + tipografia dos subitens (DASH-31: Roboto Regular 18).
    // O texto e renderizado pelo SidebarLink, que tem folha JSS propria: o seletor
    // "$primary" daqui nao o alcanca, por isso mira na classe global do MUI.
    "& .MuiListItemText-primary": {
      fontFamily: ["Roboto", "sans-serif"].join(","),
      fontSize: 18,
      fontWeight: 400,
      "&:before": {
        content: '"\\2022"',
        marginRight: theme.spacing(1),
        opacity: 0.9
      }
    }
  },
  active: {
    backgroundColor: theme.palette.type === "dark" ? alpha(theme.palette.primary.main, 0.24) : alpha(theme.palette.common.white, 0.16),
    "& $primary": {
      color: theme.palette.common.white
    },
    "& $icon svg": {
      fill: theme.palette.common.white
    },
    "&:hover, &:focus": {
      backgroundColor: theme.palette.type === "dark" ? alpha(theme.palette.primary.main, 0.24) : alpha(theme.palette.common.white, 0.16)
    }
  },
  nolist: {
    listStyle: "none"
  },
  // DASH-31: item do menu em Roboto Medium 20
  primary: {
    whiteSpace: "nowrap",
    fontFamily: ["Roboto", "sans-serif"].join(","),
    fontSize: 20,
    fontWeight: 500
  },
  icon: {
    minWidth: theme.spacing(5),
    fill: theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.common.white
  },
  iconed: {},
  head: {
    [theme.breakpoints.down("sm")]: {
      margin: `${theme.spacing(0.5)}px 0`,
      padding: `${theme.spacing(1)}px 0`,
      paddingLeft: theme.spacing(3)
    },
    padding: `${theme.spacing(1.5)}px 0`,
    margin: `${theme.spacing(2.25)}px 0`,
    borderRadius: `0 ${theme.spacing(3)}px ${theme.spacing(3)}px 0`,
    paddingLeft: theme.spacing(3),
    "&$iconed": {
      paddingLeft: theme.spacing(3)
    },
    '& svg[class^="MuiSvgIcon"]': {
      left: -10,
      position: "relative"
    }
  },
  headCapital: {
    padding: `${theme.spacing(1)}px 0 ${theme.spacing(1)}px ${theme.spacing(9)}px`,
    left: theme.spacing(1) * -2,
    position: "relative",
    textTransform: "uppercase",
    borderRadius: `0 ${theme.spacing(3)}px ${theme.spacing(3)}px 0`,
    margin: `${theme.spacing(1)}px`,
    "& span": {
      fontSize: 14
    }
  },
  copyright: {
    color: theme.palette.text.secondary,
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
    position: "fixed",
    [theme.breakpoints.up("lg")]: {
      background: "none",
      position: "absolute"
    },
    left: theme.spacing(3),
    lineHeight: "24px"
  },
  brand: {
    [theme.breakpoints.down("sm")]: {
      padding: "16px 10px 12px"
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 10px 20px",
    width: "100%",
    boxSizing: "border-box",
    height: "auto",
    overflow: "visible",
    position: "relative",
    textDecoration: "none",
    fontSize: 16,
    margin: 0,
    fontWeight: 500,
    color: theme.palette.type === "dark" ? theme.palette.text.primary : theme.palette.common.white,
    "& img": {
      width: 56,
      margin: 0
    }
  },
  brandBig: {
    paddingTop: theme.spacing(4),
    position: "relative",
    textAlign: "center",
    "& img": {
      width: 68
    },
    "& h3": {
      fontSize: 18,
      marginTop: theme.spacing(2),
      fontWeight: 500,
      color: theme.palette.type === "dark" ? theme.palette.text.primary : theme.palette.common.white
    }
  },
  profile: {
    height: 120,
    width: "100%",
    display: "flex",
    fontSize: 14,
    padding: 10,
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
    position: "absolute",
    margin: `${theme.spacing(2)}px 0`,
    zIndex: 0,
    "& h4": {
      fontSize: 18,
      marginBottom: 0,
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      width: 110
    },
    "& button": {
      fontSize: 12,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: 110,
      display: "block",
      overflow: "hidden",
      textTransform: "capitalize",
      padding: 0,
      minHeight: 20,
      marginTop: 4
    }
  },
  statusMenu: {
    "& li": {
      width: 100
    }
  },
  dotStatus: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    display: "inline-block",
    borderRadius: "50%",
    marginRight: theme.spacing(0.5)
  },
  online: {
    backgroundColor: lightGreen[500]
  },
  bussy: {
    backgroundColor: red[500]
  },
  idle: {
    backgroundColor: amber[500]
  },
  offline: {
    backgroundColor: grey[500]
  },
  rounded: {},
  landingNav: {},
  withProfile: {},
  menuContainer: {
    overflow: "auto",
    height: "100%",
    width: drawerWidth,
    // na gaveta temporaria o paper e mais estreito que os 340px: sem isso a lista
    // estoura a largura e a altura fixa impede a rolagem interna
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "auto",
      flex: 1,
      minHeight: 0
    },
    position: "relative",
    display: "block",
    padding: `0 0 ${theme.spacing(5)}px`,
    // a logo fica dentro da area que rola para subir junto com os itens; fora dela os
    // itens passavam por baixo da logo ao rolar
    "& > $brand": {
      marginBottom: theme.spacing(2)
    },
    "&$landingNav": {
      [theme.breakpoints.up("lg")]: {
        paddingTop: theme.spacing(5)
      },
      [theme.breakpoints.down("lg")]: {
        height: "calc(100% - 164px)",
        paddingTop: theme.spacing(5)
      }
    },
    "&$rounded": {
      paddingRight: theme.spacing(1.5),
      "& a": {
        borderRadius: `0 ${theme.spacing(3)}px ${theme.spacing(3)}px 0`
      },
      "& $opened": {
        "&:before": {
          background: theme.palette.primary.main
        }
      }
    },
    "&::-webkit-scrollbar": {
      width: 8
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 12,
      backgroundColor: "rgba(0,0,0,0)"
    },
    "&:hover": {
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0,0,0,0.3)",
        border: "1px solid rgba(255,255,255,0.4)"
      }
    }
  },
  divider: {
    marginTop: theme.spacing(1)
  },
  badge: {
    height: "auto"
  }
});

export default styles;
